import { render, staticRenderFns } from "./TagDots.vue?vue&type=template&id=2b6bf33c&scoped=true"
import script from "./TagDots.vue?vue&type=script&setup=true&lang=ts"
export * from "./TagDots.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./TagDots.vue?vue&type=style&index=0&id=2b6bf33c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b6bf33c",
  null
  
)

export default component.exports